<!-- Without tabs there is nothing to label a body with, so the whole component collapses. -->
@if (tabs().length > 0) {
    <div class="cerrix-tab-strip" role="tablist">
        @for (tab of tabs(); track tab) {
            <button
                class="tab"
                type="button"
                role="tab"
                [class.active]="tab === activeTab()"
                [attr.aria-selected]="tab === activeTab()"
                [attr.aria-controls]="panelId"
                (click)="select(tab)"
            >
                {{ tab.label() }}
            </button>
        }
    </div>

    <div
        class="cerrix-tab-body"
        role="tabpanel"
        [id]="panelId"
        [attr.aria-label]="activeTab().label()"
    >
        <ng-container [ngTemplateOutlet]="activeTab().template" />
    </div>
}
